module.exports = __webpack_public_path__ + "static/media/image4.6e527d28.jpg";